module.exports = __webpack_public_path__ + "static/media/portfolio.030ea568.PNG";